import { useState, useEffect } from 'react';
import { useTextForm } from '../useTextForm';

export const useAdminTextForm = (textForm, isLoading) => {
  const base = useTextForm(textForm, isLoading);
  const [initialTextContent, setInitialTextContent] = useState('');
  const [initialHtmlContent, setInitialHtmlContent] = useState('');
  const [initialStuffedKeywords, setInitialStuffedKeywords] = useState([]);
  const [threadId, setThreadId] = useState(null);
  const [isTextVerified, setIsTextVerified] = useState(false);

  useEffect(() => {
    if (!textForm) return;

    setInitialTextContent(textForm.initialTextContent || '');
    setInitialHtmlContent(textForm.initialHtmlContent || '');
    setInitialStuffedKeywords(textForm.initialStuffedKeywords || []);
    setThreadId(textForm.threadId || null);
    setIsTextVerified(textForm.verifiedByAdmin || false);
  }, [textForm, isLoading]);

  return {
    ...base,
    initialTextContent,
    initialHtmlContent,
    initialStuffedKeywords,
    threadId,
    isTextVerified,
    setInitialTextContent,
    setInitialHtmlContent,
    setInitialStuffedKeywords,
    setThreadId,
    setIsTextVerified,
  };
};
